import { render, staticRenderFns } from "./model-tree.vue?vue&type=template&id=2bab5700&scoped=true"
import script from "./model-tree.vue?vue&type=script&lang=js"
export * from "./model-tree.vue?vue&type=script&lang=js"
import style0 from "./model-tree.vue?vue&type=style&index=0&id=2bab5700&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab5700",
  null
  
)

export default component.exports